import { useRouter } from 'next/router';
import React, { FC, Fragment } from 'react';
import { NextLink, Translate, useTranslate } from '~/i18n';
import classNames from 'classnames';
import styles from './styles.module.css';
import { AngelLeftIcon, AngelRightIcon } from '~/svgs/common';
import { publicUrl } from '~/utils/publicUrl';
import { BreadcrumbJsonLd } from 'next-seo';
import { ItemListElements } from 'next-seo/lib/jsonld/breadcrumb';
interface BreadcrumbProps extends React.HTMLProps<HTMLDivElement> {
   lastBreadClassName?: string;
   lastBreadCrumbText?: string;
   breadCrumbColor?: string;
}

const Breadcrumb: FC<BreadcrumbProps> = ({
   lastBreadClassName,
   lastBreadCrumbText,
   breadCrumbColor,
   ...props
}) => {
   const router = useRouter();
   const { dir } = useTranslate();
   const links = router.asPath?.split('/');
   links.splice(0, 2);

   const getHref = (idx: number) => {
      return links.slice(0, idx + 1).join('/');
   };

   const breadcrumb: ItemListElements[] = links.map((link, idx) => {
      return {
         // Remove all ["], rich snippet breaks with ["]
         name: link.replace(/-/g, ' ')?.split('?')[0]?.replace(/"/g, ''),
         position: idx + 1,
         item: publicUrl(getHref(idx)),
      };
   });

   return (
      <div {...props}>
         <BreadcrumbJsonLd itemListElements={breadcrumb} />
         <ul className={styles['breadcrumb']}>
            {links.map((link: string, idx) => {
               const href = getHref(idx);
               const formattedItem = decodeURI(link.replace(/-/g, ' ')?.split('?')[0]);
               return (
                  <li key={idx} className="capitalize flex items-center leading-none text-white">
                     {idx === links.length - 1 ? (
                        <span
                           className={classNames(
                              breadCrumbColor,
                              lastBreadClassName || 'opacity-75'
                           )}>
                           {lastBreadCrumbText ? (
                              lastBreadCrumbText
                           ) : (
                              <Translate
                                 id={`business:${link.replace(/-/g, ' ')}`}
                                 fallback={formattedItem}
                              />
                           )}
                        </span>
                     ) : (
                        <Fragment>
                           <NextLink href={`/${href}`}>
                              <div className={breadCrumbColor}>
                                 <Translate
                                    id={`business:${link.replace(/-/g, ' ')}`}
                                    fallback={formattedItem}
                                 />
                              </div>
                           </NextLink>
                           <div>
                              {dir === 'rtl' ? (
                                 <AngelLeftIcon
                                    className={classNames('transform scale-75', breadCrumbColor)}
                                 />
                              ) : (
                                 <AngelRightIcon
                                    className={classNames('transform scale-75', breadCrumbColor)}
                                 />
                              )}
                           </div>
                        </Fragment>
                     )}
                  </li>
               );
            })}
         </ul>
      </div>
   );
};
Breadcrumb.displayName = 'Breadcrumb';
export default React.memo(Breadcrumb);
